// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import GateConstants from 'constants/GateConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

const GateQueries = Marty.createQueries({
  id: 'GateQueries',

  setGate(orgId, gateName, value) {
    const promise = this.app.sources.GateAPI.setGate(orgId, gateName, value)

    promise.then(res => {
      if (res.status === 200) {
        return this.dispatch(GateConstants.SET_GATE_DONE, res.body)
      } else {
        captureResponseException(res)
        return this.dispatch(GateConstants.SET_GATE_FAILED, res)
      }
    })

    return promise.catch(error => {
      captureException(error)
      return this.dispatch(GateConstants.SET_GATE_FAILED, error)
    })
  }
})

export default GateQueries



// WEBPACK FOOTER //
// ./src/scripts/queries/GateQueries.js